import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.16_@opentelemetry+api@1.9.0_react-dom@19.2.6_react@19.2.6__react@19.2.6/node_modules/next/dist/client/script.js");
